import agent from './agent';
import config from '../config.json';
import ServiceBase from './ServiceBase';

const baseUrl = config.baseUrl;
const service = 'jernygateway';

// krakend - KDesk
// const baseUrl = 'http://localhost:8080';
// const service = 'datacollector';

class WindowManagerService extends ServiceBase {
    /**
     * Saves a new or updated WindowPosition.
     * @param {object} dto - { rk?, title, body, format, templateVer }
     * @returns {Promise}
     */
    postWindowPosition = (dto) => {
        if (dto === undefined) {
            return;
        }

        if (!dto.height) dto.height = 0;
        if (!dto.width) dto.width = 0;

        const url = `${baseUrl}/${service}/windowManager/position`;
        const config = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };
        return agent.post(url, { data: dto }, config);
    };

    /**
     * Fetches all WindowPosition for the current user.
     * @returns {Promise}
     */
    getWindowPositions = (tabId) => {
        const url = `${baseUrl}/${service}/windowManager/positions?tabId=${tabId}`;
        const config = { headers: { Authorization: `Bearer ${this.getToken()}` } };
        return agent.get(url, config);
    };

    /**
     * Updates WindowPosition
     * @param {object} req WindowPosition
     * @returns {Promise}
     */
    patchWindowPosition = (req) => {
        const url = `${baseUrl}/${service}/WindowPosition`;
        const cfg = {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                'Content-Type': 'application/json',
            },
        };

        // Wrap in data envelope
        return agent.patch(url, { data: req }, cfg);
    };

    /**
     * Deletes a WindowPosition by RK.
     *
     * @param {*} dto - { Rk }
     * @returns axios response
     */
    deleteWindowPosition = (dto) => {
        const url = `${baseUrl}/${service}/WindowPosition`;
        const cfg = {
            data: { data: dto },
            headers: { Authorization: `Bearer ${this.getToken()}` },
        };
        return agent.delete(url, cfg);
    };
}

const windowManagerService = new WindowManagerService();
export default windowManagerService;
